<div class="mb-4">
    <div class="card-body" [class.placeholder-glow]="isLoading()">
        <!-- Title and Description -->
        <div class="mb-4">
            @if (isLoading()) {
                <div class="placeholder col-4 mb-2" style="height: 2rem;"></div>
                <div class="placeholder col-6"></div>
            } @else {
                <h1 class="fw-bold mb-2">{{ summary()?.name }}</h1>
                @if (summary()?.description) {
                    <p class="text-muted mb-0">{{ summary()?.description }}</p>
                }
            }
        </div>

        <!-- Summary Stats Grid -->
        <div class="row g-3">
            <!-- Total Amount Invoiced -->
            <div class="col-6 col-md-4 col-lg">
                <div class="border rounded p-3 h-100">
                    <div class="text-muted small mb-1">Total Amount Invoiced</div>
                    @if (isLoading()) {
                        <div class="placeholder col-6"></div>
                    } @else {
                        <div class="fw-bold fs-5">{{ formattedTotalChargedAmount() }}</div>
                    }
                </div>
            </div>

            <!-- Total Number of Invoices -->
            <div class="col-6 col-md-4 col-lg">
                <div class="border rounded p-3 h-100">
                    <div class="text-muted small mb-1">Total Invoices</div>
                    @if (isLoading()) {
                        <div class="placeholder col-4"></div>
                    } @else {
                        <div class="fw-bold fs-5">{{ summary()?.chargesGeneratedCount | number }}</div>
                    }
                </div>
            </div>

            <!-- Asset Type -->
            <div class="col-6 col-md-4 col-lg">
                <div class="border rounded p-3 h-100">
                    <div class="text-muted small mb-1">Asset Type</div>
                    @if (isLoading()) {
                        <div class="placeholder col-8"></div>
                    } @else {
                        <div class="fw-semibold fs-6">
                            {{ summary()?.assetAccount?.name }}
                            @if (summary()?.assetAccount?.isActive === false) {
                                <span class="badge bg-warning-subtle text-warning-emphasis ms-1">Retired</span>
                            }
                        </div>
                    }
                </div>
            </div>

            <!-- Revenue Type -->
            <div class="col-6 col-md-4 col-lg">
                <div class="border rounded p-3 h-100">
                    <div class="text-muted small mb-1">Revenue Type</div>
                    @if (isLoading()) {
                        <div class="placeholder col-8"></div>
                    } @else {
                        <div class="fw-semibold fs-6">
                            {{ summary()?.revenueAccount?.name }}
                            @if (summary()?.revenueAccount?.isActive === false) {
                                <span class="badge bg-warning-subtle text-warning-emphasis ms-1">Retired</span>
                            }
                        </div>
                    }
                </div>
            </div>

            <!-- Next Issue Date -->
            <div class="col-6 col-md-4 col-lg">
                <div class="border rounded p-3 h-100">
                    <div class="text-muted small mb-1">Next Issuance Date</div>
                    @if (isLoading()) {
                        <div class="placeholder col-6"></div>
                    } @else {
                        <div class="fw-bold fs-6">{{ (summary()?.nextIssuanceDate | orgDate: 'longDate') ?? 'None' }}</div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
